// apps/merchant-v3/src/components/banners/BannerStack.tsx
//
// Phase 6 Wave 12 Task 42 — Composes the persistent banner stack rendered
// at the very top of AppShell. Priority order, top → bottom:
//
//   1. ImpersonateBanner — yellow, admin viewing-as marker
//   2. SuspendBanner — red, persistent merchant lockdown
//   3. OverdueInvoiceBanner — yellow, dismissible per session
//   4. PromoBanner — coloured, dismissible (Task 43)
//
// This component owns the priority + ordering ONLY — each child decides
// whether to render based on its own data source. No-op when no banner
// has data to show (preserves original AppShell vertical rhythm).
//
// Phase 6 Wave 12 Task 43 — repointed PromoBanner from the legacy
// `@/components/PromoBanner` (admin-content shape) to the new
// `./PromoBanner` (priority + expiresAt projection).
//
// vg-binding: PLAN:task-42
// vg-binding: PLAN:task-43
// vg-binding: P6.D-114
// vg-binding: P6.D-128
// vg-binding: P6.D-130
// vg-binding: P6.D-222
// vg-binding: P6.D-226
// vg-binding: P6.D-246
// vg-binding: P6.D-247
// vg-binding: P6.D-248
// vg-binding: G-70
// vg-binding: G-71
// vg-binding: G-72

import type { JSX } from 'react';

import { ImpersonateBanner } from '@/components/security/ImpersonateBanner';
import { BEPrereqsBanner } from '@/components/BEPrereqsBanner';
import { SuspendBanner } from './SuspendBanner';
import { OverdueInvoiceBanner } from './OverdueInvoiceBanner';

// Promo banner moved to TopBar (inline pill) per UX feedback 2026-05-23 —
// BannerStack keeps only full-width strip banners.

export function BannerStack(): JSX.Element {
  return (
    <div className="flex flex-col" data-testid="banner-stack">
      {/* 1. Impersonate (highest priority — admin context). */}
      <ImpersonateBanner />

      {/* 1b. Cross-phase BE prereq — keeps the existing Wave 2 surface
              visible inside the stack instead of competing for the AppShell
              top-of-flex slot. */}
      <BEPrereqsBanner />

      {/* 2. Persistent suspend — sticky red. */}
      <SuspendBanner />

      {/* 3. Overdue invoice — dismissible yellow. */}
      <OverdueInvoiceBanner />
    </div>
  );
}

export default BannerStack;
